import http from '../../http'

export async function validateSession() {
  return http.get('/Auth/validate-session')
}

export async function signOut() {
  return http.get('/Auth/logout')
}

export async function oidcCallback(code) {
  const sessid = localStorage.getItem('sessid')
  return http.get(`/Auth/oidc-callback?code=${code}&sessid=${sessid}`)
}

export async function userInfo() {
  return http.get('/Auth/user-info')
}

export async function authTrustHub() {
  return http.get('/Auth/trusthub-authenticate')
}
